import { Globe } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface LanguageDetectionBadgeProps {
  language: string;
  confidence?: number;
  className?: string;
}

const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  no: 'Norwegian',
  sv: 'Swedish', 
  da: 'Danish',
  fi: 'Finnish',
  de: 'German',
  fr: 'French'
};

export const LanguageDetectionBadge = ({ 
  language, 
  confidence, 
  className 
}: LanguageDetectionBadgeProps) => {
  const languageName = LANGUAGE_NAMES[language] || language.toUpperCase();
  const confidencePercent = confidence ? Math.round(confidence * 100) : undefined;
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            variant="secondary" 
            className={`flex items-center gap-1 text-xs ${className}`}
          >
            <Globe className="h-3 w-3" />
            {languageName}
            {confidencePercent && ` (${confidencePercent}%)`}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            Detected language: {languageName}
            {confidencePercent && ` with ${confidencePercent}% confidence`}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};